import React, { useState, forwardRef } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import styles from './FormInput.module.scss'
import FormattedMessage from '../../helpers/FormattedMessage'
import calendarIcon from '../../assets/icons/icn_calendar.png'
import checkIcon from '../../assets/icons/icn_check_green.png'

interface IProps {
  title: string
  onChange: any
  value: any
  startDay?: Date | undefined
  endDay?: Date | undefined
  validate?: (d:Date) => boolean
}

export const FormDate = ({
  title,
  value,
  onChange,
  startDay,
  endDay,
  validate
}: IProps) => {
  const [state, setState] = useState(value)

  const valid = validate
    ? validate(value)
    : value
      ? true
      : false

  const onDateChange = (date: any) => {
    setState(date)
    onChange(date)
  }

  const ExampleCustomInput = forwardRef(({ value, onClick }: { value?: any, onClick?: any }, ref: any) => (
    <button className={styles.DateButton} onClick={onClick} ref={ref}>
      {value}
    </button>
  ))

  return (
    <div className={styles.Wrapper}>
      <div className={styles.FormItem}>

      <img src={calendarIcon} className={styles.MagnifyIcon} alt="calendar"/>

        <div className={styles.InfoContainer}>
          <h4 className={styles.Title}>
            <FormattedMessage id={title} />
          </h4>
          <DatePicker
            dateFormat="dd/MM/yyyy"
            minDate={startDay}
            maxDate={endDay}
            selected={state}
            onChange={(date: Date | [Date | null, Date | null] | null) => onDateChange(date)}
            customInput={<ExampleCustomInput value={null} onClick={null} />}
          />
          { validate && valid && <img src={checkIcon} className={styles.CheckIcon} alt="valid"/> }
        </div>
      </div>
    </div>
  )
}
